import { useCallback, useMemo } from 'react';
import { adminApi } from '../../services/adminApi';
import AdminGrid from '../../components/admin/AdminGrid';
import StatusBadge from '../../components/admin/StatusBadge';

const fmtOverdue = (p) => {
  const val = p.value;
  if (!val || val <= 0) return '-';
  if (val > 1440) return `${Math.round(val / 1440)}d`;
  if (val > 60) return `${Math.round(val / 60)}h`;
  return `${val}m`;
};

export default function AutoRefreshMonitor() {
  const columns = useMemo(() => [
    { field: 'status', headerName: 'Status', cellRenderer: StatusBadge, minWidth: 120 },
    { field: 'accountEmail', headerName: 'Account Email', minWidth: 200 },
    { field: 'sheetName', headerName: 'Sheet Name', minWidth: 180 },
    { field: 'reportType', headerName: 'Report Type' },
    { field: 'syncFrequency', headerName: 'Frequency' },
    { field: 'lastSyncAt', headerName: 'Last Sync', valueFormatter: (p) => p.value ? new Date(p.value).toLocaleString() : 'Never' },
    { field: 'overdueMinutes', headerName: 'Overdue', valueFormatter: fmtOverdue, filter: 'agNumberColumnFilter' },
    { field: 'realmId', headerName: 'Realm ID' },
  ], []);

  const fetchData = useCallback(async () => {
    const res = await adminApi.getOverdueAutoRefresh();
    return Array.isArray(res) ? res : res.content || [];
  }, []);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-100 mb-4">Auto-Refresh Monitor</h1>
      <AdminGrid columns={columns} fetchData={fetchData} />
    </div>
  );
}
